module.exports = __webpack_public_path__ + "static/media/car7.6030eb56.jpg";